<template>
  <div
    v-if="catalogData"
    :class="{
      'product-detail-head-fi': true,
      'product-detail-head-fite-fi': true,
      'product-detail-head-fi--no-margin-bottom': noMarginBottom,
    }"
  >
    <grid-container-fi>
      <div class="fi-col-start-1 fi-col-end-13 md:fi-col-end-7">
        <catalog-slider-fi
          :catalog-data="catalogData"
          :item-name="productName"
        />
      </div>
      <div class="fi-col-start-1 fi-col-end-13 md:fi-col-start-7 md:fi-col-end-13">
        <div
          v-if="isNew"
          class="product-detail-head-fi__badge"
        >
          <span class="product-detail-head-fi__badge__text"
            >{{ $dict.get('online-Shop.Product.New-Product-Badge') }}
          </span>
        </div>

        <headline-fi
          v-if="articleNumber"
          class="product-detail-head-fi__art-nr"
          tag="div"
          color="grey-dark"
          :size="18"
          :html-content="articleNumber"
        />
        <headline-fi
          v-if="marketingClaim"
          class="product-detail-head-fi__marketing-claim"
          tag="h2"
          color="brand"
          :size="24"
          :html-content="marketingClaim"
        />
        <headline-fi
          v-if="productName"
          class="product-detail-head-fi__name"
          tag="h1"
          :size="48"
          :html-content="productName"
        />

        <div class="product-detail-head-fi__links">
          <link-fi
            v-if="categorySlug"
            class="product-detail-head-fi__link"
            :href="categorySlug"
            :size="18"
          >
            {{ $dict.get('product-Family.Anchor-Link-Text') }}
          </link-fi>

          <link-fi
            v-if="eLearningLink"
            class="product-detail-head-fi__link"
            :href="eLearningLink.Url"
            :external="Boolean(eLearningLink.Url)"
            :size="18"
          >
            {{ $dict.get('online-Shop.Product.E-Learning-Link') }}
          </link-fi>

          <link-fi
            v-if="
              fields.customLink?.value &&
              (fields.customLink.value.href || fields.customLink.value.url)
            "
            class="product-detail-head-fi__link"
            :href="
              fields.customLink.value.href
                ? fields.customLink.value.href
                : fields.customLink.value.url
            "
            :external="Boolean(fields.customLink.value.url)"
            :target="fields.customLink.value.target"
            :size="18"
          >
            {{ fields.customLink.value.text }}
          </link-fi>

          <link-fi
            v-if="mediaDownloadLink && fields.mediaDownloadLabel?.value"
            class="product-detail-head-fi__link"
            href="#"
            rel="nofollow"
            :size="18"
            @click.stop.prevent="openMediaDownloadDialog"
          >
            {{ fields.mediaDownloadLabel.value }}
          </link-fi>
        </div>
        <grid-columns-fi :columns="6">
          <div class="fi-col-span-6 lg:fi-col-span-5">
            <div class="product-detail-head-fi__features">
              <text-expander-fi
                v-if="features"
                :content="{ value: features }"
                :max-height="400"
                :expand-text="$dict.get('global-Labels.Expander.Expand')"
                :reduce-text="$dict.get('global-Labels.Expander.Reduce')"
              />
            </div>

            <div class="product-detail-head-fi__attributes">
              <product-attributes-fi :attributes="attributes" />
            </div>

            <template v-if="shopifyEnabled">
              <loading-indicator-wrapper
                :loading="!isMounted"
                variant="spinnerLocal"
                class="product-detail-head-fi__shopify"
              >
                <div id="product-component-1743423183593" />
              </loading-indicator-wrapper>

              <ul class="product-detail-head-fi__shopify__list">
                <li v-if="fields.shippingCosts?.value">{{ fields.shippingCosts.value }}</li>
                <li v-if="fields.freeOfCharge?.value">{{ fields.freeOfCharge.value }}</li>
                <li v-if="fields.deliveryTime?.value">{{ fields.deliveryTime.value }}</li>
                <li v-if="fields.rightOfWithdrawal?.value">{{ fields.rightOfWithdrawal.value }}</li>
              </ul>
            </template>

            <template v-else>
              <template v-if="productPrice">
                <div
                  class="product-detail-head-fi__price"
                  data-test="product-price"
                >
                  {{ $dict.get('online-Shop.Product.UVP-Price-Prefix') }} {{ productPrice }}
                </div>

                <div class="product-detail-head-fi__price-vat">
                  {{ $dict.get('online-Shop.Product.Vat-included') }}
                </div>
              </template>

              <div
                v-if="retailers || shopUrl"
                class="product-detail-head-fi__retail-connect-cart-actions product-detail-head-fi__retail-connect-cart-actions--md"
              >
                <!-- PLACEHOLDER FOR FUTURE ADD TO FAVOURITE LIST -->
                <div />

                <button-fi
                  v-if="retailers.length || (!retailers.length && !shopUrl)"
                  class="button-fi__primary--large button__to-retailer"
                  type="button"
                  data-test="open-retailers"
                  :disabled="!retailers.length"
                  @click.stop.prevent="openProductRetailerDialog"
                >
                  {{ $dict.get('online-Shop.Product.Retail-Connect.Show-Retailers') }}
                </button-fi>

                <button-fi
                  v-else-if="shopUrl"
                  :href="shopUrl"
                  target="_blank"
                  rel="noopener"
                  class="button-fi__primary--large"
                  natural-events
                  @natural-click="onShopUrlClicked"
                >
                  {{ $dict.get('online-Shop.Product.Retail-Connect.Buy-Product') }}
                </button-fi>
              </div>
            </template>
          </div>
        </grid-columns-fi>
      </div>

      <media-download-dialog-fi
        ref="mediaDownloadDialog"
        :media-download-link="mediaDownloadLink"
        :fields="fields"
      />

      <product-retailer-dialog-fite-fi
        ref="productRetailerDialog"
        :retailers="retailers"
      />
    </grid-container-fi>

    <span
      v-intersect="onIntersect"
      class="sticky-actions-intersector"
    />
    <div
      v-if="!shopifyEnabled && (retailers || shopUrl)"
      :class="{
        'product-detail-head-fi__actions-mobile': true,
        'product-detail-head-fi__actions-mobile--sticky': stickyEnabled,
      }"
    >
      <div class="product-detail-head-fi__retail-connect-cart-actions">
        <!-- PLACEHODER FOR FUTURE ADD TO FAVOURITE LIST -->
        <div v-if="isSM" />

        <button-fi
          v-if="retailers.length || (!retailers.length && !shopUrl)"
          type="button"
          class="button-fi__primary--large button__to-retailer"
          :disabled="!retailers.length"
          @click.stop.prevent="openProductRetailerDialog"
        >
          {{ $dict.get('online-Shop.Product.Retail-Connect.Show-Retailers') }}
        </button-fi>

        <button-fi
          v-else-if="shopUrl"
          :href="shopUrl"
          target="_blank"
          rel="noopener"
          class="button-fi__primary--large button__to-retailer"
          natural-events
          @natural-click="onShopUrlClicked"
        >
          {{ $dict.get('online-Shop.Product.Retail-Connect.Buy-Product') }}
        </button-fi>
      </div>
    </div>
  </div>
</template>

<script>
import { ButtonFi, HeadlineFi, LinkFi, LoadingIndicatorWrapper } from 'atoms';

import CatalogSliderFi from '@/components/catalog-slider-fi/CatalogSliderFi.vue';
import GridColumnsFi from '@/components/grid-fi/GridColumnsFi.vue';
import GridContainerFi from '@/components/grid-fi/GridContainerFi.vue';
import MediaDownloadDialogFi from '@/components/product-detail/media-download-dialog-fi/MediaDownloadDialogFi.vue';
import ProductAttributesFi from '@/components/product-detail/product-detail-head-fi/product-attributes-fi/ProductAttributesFi.vue';
import ProductRetailerDialogFiteFi from '@/components/product-detail/product-retailer-dialog-fi/ProductRetailerDialogFiteFi.vue';
import TextExpanderFi from '@/components/text-expander-fi/TextExpanderFi.vue';
import { usePriceCurrency } from '@/composables/priceCurrency';
import breakpointMixin from '@/mixins/breakpointMixin.vue';
import catalogTextListMixin from '@/mixins/catalogTextListMixin.vue';
import theme from '@/plugins/tailwind-theme';

export default {
  name: 'ProductDetailHeadFiteFi',
  components: {
    ButtonFi,
    LoadingIndicatorWrapper,
    CatalogSliderFi,
    GridContainerFi,
    GridColumnsFi,
    HeadlineFi,
    LinkFi,
    MediaDownloadDialogFi,
    TextExpanderFi,
    ProductAttributesFi,
    ProductRetailerDialogFiteFi,
  },
  mixins: [breakpointMixin, catalogTextListMixin],
  inject: ['fields'],
  props: {
    catalogData: {
      type: Object,
      default: null,
    },
    mediaDownloadLink: {
      type: String,
      default: null,
    },
    noMarginBottom: Boolean,
  },
  setup() {
    return usePriceCurrency();
  },
  data() {
    return {
      stickyEnabled: false,
      isNew: false,
      isMounted: false,
      shopifyLoaded: false,
    };
  },
  computed: {
    articleNumber() {
      const artNr = this.catalogData?.ProductId;
      return `${this.$dict.get('product-List.Table.Article-Number')} ${artNr}`;
    },
    marketingClaim() {
      return this.textListValue(this.catalogData?.TextList, 'DOKBSTMARKCLAIM');
    },
    categorySlug() {
      return (
        this.catalogData?.categoryData?.CategoryRole === 'FAMILY_PAGE' &&
        this.catalogData?.categoryData?.Slug &&
        `${this.$fischer.pages.products().url}${this.catalogData.categoryData.Slug}#productList`
      );
    },
    productName() {
      return this.textListValue(this.catalogData?.TextList, 'ECOMLANG');
    },
    productPrice() {
      if (this.catalogData?.ProductPrice && this.catalogData.ProductPriceCurrency) {
        return this.formatPrice(
          this.catalogData.ProductPrice,
          this.catalogData.ProductPriceCurrency,
        );
      }

      return null;
    },
    features() {
      return this.textListValue(this.catalogData?.TextList, 'POCTOPFEATURESGEN');
    },
    attributes() {
      return this.catalogData?.Attributes;
    },
    shopUrl() {
      const shopLink = this.catalogData?.Links?.find((el) => el.Type === 'SHOP');
      return shopLink?.Url || null;
    },
    eLearningLink() {
      if (!this.catalogData || !this.catalogData.Links) {
        return null;
      }

      return this.catalogData?.Links?.find((l) => l.Type === 'ELEARNING');
    },
    retailers() {
      return this.catalogData?.RetailerLinks;
    },
    shopifyId() {
      return this.catalogData?.ExternalIds?.find((el) => el.Key === 'ShopifyID')?.Value;
    },
    shopifyEnabled() {
      return Boolean(
        this.fields.enableShopify?.value &&
          this.fields.storefrontAccessToken?.value &&
          this.shopifyId,
      );
    },
  },
  watch: {
    catalogData(newValue) {
      if (newValue) {
        this.loadShopify();
      }
    },
  },
  mounted() {
    this.loadShopify();
    this.isMounted = true;
  },
  methods: {
    openMediaDownloadDialog() {
      this.$refs.mediaDownloadDialog.show();
    },
    openProductRetailerDialog() {
      this.$refs.productRetailerDialog.show();
    },
    onIntersect(observer) {
      this.stickyEnabled = !observer[0].isIntersecting && observer[0].boundingClientRect.top > 0;
    },
    onShopUrlClicked() {
      // TRACKING EVENT
      if (!IS_SSR) {
        const productName = `${this.catalogData.ProductId} - ${this.productName}`;
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'RCBuyProduct',
          productName,
        });
      }
    },
    loadShopify() {
      if (IS_SSR || this.shopifyLoaded || !this.shopifyEnabled) {
        return;
      }

      if (window.ShopifyBuy) {
        if (window.ShopifyBuy.UI) {
          this.shopifyBuyInit();
        } else {
          this.loadScript();
        }
      } else {
        this.loadScript();
      }

      this.shopifyLoaded = true;
    },
    loadScript() {
      const scriptURL =
        'https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js';
      const script = document.createElement('script');
      script.async = true;
      script.src = scriptURL;
      window.document.body.appendChild(script);
      script.onload = this.shopifyBuyInit;
    },
    shopifyBuyInit() {
      const id = this.shopifyId;
      // eslint-disable-next-line no-undef
      const client = ShopifyBuy.buildClient({
        domain: 'na8dhb-dd.myshopify.com',
        storefrontAccessToken: this.fields?.storefrontAccessToken?.value,
      });
      // eslint-disable-next-line no-undef
      ShopifyBuy.UI.onReady(client).then((ui) => {
        ui.createComponent('product', {
          id,
          node: document.getElementById('product-component-1743423183593'),
          moneyFormat: '%7B%7Bamount_with_comma_separator%7D%7D%20%E2%82%AC%0A',
          options: {
            product: {
              iframe: false,
              buttonDestination: 'cart',
              templates: {
                description: `<div class="shopify-buy__hint">${this.$dict.get('online-Shop.Product.Vat-included')}</div>`,
              },
              text: {
                button: this.fields?.addToCartButton?.value,
                outOfStock: this.fields?.outOfStockButton?.value,
                unavailable: this.fields?.unavailableButton?.value,
              },
              contents: {
                img: false,
                title: false,
                description: true,
              },
              classes: {
                button: 'button-fi__primary--large',
              },
            },
            toggle: {
              styles: {
                toggle: {
                  color: theme.fite?.white,
                  'background-color': theme.fite?.brand,
                  ':hover': {
                    'background-color': theme.fite?.grey,
                  },
                  ':focus': {
                    'background-color': theme.fite?.grey,
                  },
                },
              },
            },
            cart: {
              buttonDestination: 'checkout',
              text: {
                title: this.fields?.cartTitle?.value,
                empty: this.fields?.cartEmpty?.value,
                button: this.fields?.cartBuyButton?.value,
                total: this.fields?.cartTotal?.value,
                notice: this.fields?.cartNotice?.value,
                noteDescription: this.fields?.cartNoteDescription?.value,
              },
              styles: {
                button: {
                  color: theme.fite?.white,
                  'background-color': theme.fite?.brand,
                  ':hover': {
                    'background-color': theme.fite?.grey,
                  },
                  ':focus': {
                    'background-color': theme.fite?.grey,
                  },
                },
              },
            },
          },
        });
      });
    },
  },
};
</script>

<style scoped src="./product-detail-head-fi_product-detail-head-fite-fi" />

<style src="./product-detail-head-fi_product-detail-head-fite-fi-unscoped" />
